import CancelIcon from '@mui/icons-material/Cancel';
import Clear from '@mui/icons-material/Clear';
import PersonAdd from '@mui/icons-material/PersonAdd';
import SaveIcon from '@mui/icons-material/Save';
import ThumbDown from '@mui/icons-material/ThumbDown';
import {
    Box,
    Button,
    Checkbox,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Radio,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';
import { red } from '@mui/material/colors';
import { action, computed, makeObservable, observable, reaction, runInAction, toJS, when } from 'mobx';
import { inject, observer } from 'mobx-react';

import {
    aplicarIconesImpedimento,
    filtrarImpedimentosMagistrado,
    filtrarOpcoesDisponiveis,
    getComposicaoPadraoSessao,
    getOpcoesMagistrados
} from '@/util/ImpedimentosMagistrados.js';

import Configuracao from '../../util/Configuracao';
import AutoComplete from '../AutoComplete';
import ReactComponent from '../ReactComponent';
import RelatorChip from '../shared/RelatorChip';
import BotaoAlternarSigla from './BotaoAlternarSigla';
import {
    renderAvisoMagistradoJaSubstituto,
    renderBotaoRedefinirComposicao,
    renderCelulaSubstituto,
    renderChipOrigemSigla,
    renderDialogRemocao,
    renderIconeSubstituicao
} from './ComposicaoRenders';
import ComposicaoUtil from './ComposicaoUtil';
import ModalConfirmacao from './ModalConfirmacao';
import ObservacaoCertidaoUtil from './ObservacaoCertidaoUtil';

class ModalComposicao extends ReactComponent {
    novaComposicao = [];
    novaComposicaoInicial = [];
    magistradoParaAdicionar = {};
    dialogRemocaoAberto = false;
    fraseDialogRemocao = '';
    magistradoParaRemover = {};
    atualizarCertidao = false;
    exibirAtualizarCertidao = false;
    modalConfirmacaoOpen = false;

    onModalOpen = () => {
        this.resetarEstadoModal();
    };

    resetarEstadoModal = () => {
        this.novaComposicao = toJS(this.registro.composicao);
        this.novaComposicaoInicial = JSON.stringify(toJS(this.listaComposicao(this.novaComposicao)));

        this.exibirAtualizarCertidao =
            this.props.exibirOpcaoAtualizarCertidao === undefined
                ? this.registro.certidaoGerada && !this.registro.certidaoJulgamentoAssinada
                : this.props.exibirOpcaoAtualizarCertidao;

        this.atualizarCertidao = false;
        this.completarMagistradosSubstituidos();
    };

    callbackConfirmar = () => {
        this.modalConfirmacaoOpen = false;
        this.props.onClose?.();
    };

    callbackCancelar = () => {
        this.modalConfirmacaoOpen = false;
    };

    fechar = () => {
        const composicaoAtual = JSON.stringify(toJS(this.listaComposicao(this.novaComposicao)));

        if (this.novaComposicaoInicial === composicaoAtual) {
            this.props.onClose?.();
        } else {
            this.modalConfirmacaoOpen = true;
        }
    };

    fecharSemEdicao = () => {
        if (typeof this.props.onClose === 'function') {
            this.props.onClose();
        }

        this.modalConfirmacaoOpen = true;
    };

    completarMagistradosSubstituidos = () => {
        const magistradosSubstituindo = this.novaComposicao.filter((comp) => {
            return (
                comp.magistrado.magistradoSubstituido !== null && comp.magistrado.magistradoSubstituido !== undefined
            );
        });

        runInAction(() => {
            for (const mag of magistradosSubstituindo) {
                const jaExiste = this.novaComposicao.some(
                    (comp) => comp.magistrado.sigla === mag.magistrado.magistradoSubstituido.sigla
                );

                if (!jaExiste) {
                    mag.magistrado.magistradoSubstituido.siglaSubstituto = mag.magistrado.sigla;
                    const substituto = ComposicaoUtil.resumoMagistrado(mag.magistrado);

                    mag.magistrado.magistradoSubstituido.magistradoSubstituto = substituto;
                    mag.magistrado.magistradoSubstituido.presidenteSessao = false;
                    const substituido = { magistrado: mag.magistrado.magistradoSubstituido };
                    const impedimento = this.impedimentos.find(
                        (imped) => imped.magistrado.sigla === substituido.magistrado.sigla
                    );

                    if (impedimento) {
                        substituido.magistrado.situacaoImpedimento = impedimento.situacaoImpedimento;
                    } else {
                        substituido.magistrado.ausente = true;
                    }

                    this.novaComposicao.push(substituido);
                    this.novaComposicaoInicial = JSON.stringify(toJS(this.listaComposicao(this.novaComposicao)));
                }
            }
        });
    };

    toggleMagistradoAusente = (_index, magistrado) => {
        magistrado.ausente = !magistrado.ausente;

        if (magistrado.ausente) {
            magistrado.situacaoImpedimento = undefined;
            magistrado.suspeito = false;
        }
    };

    toggleMagistradoImpedido = (magistrado, situacaoImpedimento) => {
        magistrado.situacaoImpedimento =
            magistrado.situacaoImpedimento === situacaoImpedimento ? undefined : situacaoImpedimento;

        if (magistrado.situacaoImpedimento) {
            magistrado.ausente = false;
            magistrado.suspeito = false;
        }
    };

    callbackAutoCompleteAddMagistrado = (option) => {
        this.magistradoParaAdicionar = option?.valor ?? {};
    };

    abrirDialogoRemocao = () => {
        this.dialogRemocaoAberto = true;
    };

    fecharDialogoRemocao = () => {
        this.dialogRemocaoAberto = false;
    };

    handleClickRemoverMagistrado = (magistrado) => {
        const roles = this.getRolesMagistrado(magistrado);

        if (
            roles.redator ||
            roles.relator ||
            magistrado.presidenteSessao ||
            magistrado.situacaoImpedimento ||
            this.isMagistradoSubstituto(magistrado)
        ) {
            this.removerMagistradoComRestricao(roles, magistrado);
        } else {
            this.removerMagistrado(magistrado);
        }
    };

    removerMagistradoComRestricao = (roles, magistrado) => {
        this.magistradoParaRemover = magistrado;
        const generoRemocao = magistrado.genero === 'M' ? 'o' : 'a';
        const generoRelator = magistrado.genero === 'M' ? '' : 'a';

        if (roles.relator && roles.redator) {
            this.fraseDialogRemocao =
                magistrado.nome +
                ` é Relator${generoRelator} e Redator${generoRelator} do processo e não pode ser removid${generoRemocao}.`;
        } else if (roles.relator) {
            this.fraseDialogRemocao =
                magistrado.nome + ` é Relator${generoRelator} do processo e não pode ser removid${generoRemocao}.`;
        } else if (roles.redator) {
            this.fraseDialogRemocao =
                magistrado.nome + ` é Redator${generoRelator} do processo e não pode ser removid${generoRemocao}.`;
        } else {
            this.fraseDialogRemocao =
                magistrado.nome + ' é ' + this.getRestricoes(magistrado, roles) + '. Confirma remoção?';
        }

        this.abrirDialogoRemocao();
    };

    removerMagistrado = (magistrado) => {
        if (!magistrado) {
            this.fecharDialogoRemocao();
            return;
        }

        ComposicaoUtil.removerMagistrado(this.novaComposicao, magistrado);
        this.fecharDialogoRemocao();
    };

    adicionarMagistrado = async (magistrado, substituido) => {
        let isRetorno = false;

        if (magistrado?.sigla) {
            try {
                isRetorno = await this.tentaAdicionarMagistrado(magistrado, substituido);
            } catch (error) {
                console.error(error);
                this.mensagemStore.abrirMensagemErro('Não foi possível verificar se magistrado pode ser adicionado');
            }
        } else {
            this.mensagemStore.abrirMensagemInfo('Selecione um magistrado da lista.');
        }
        return isRetorno;
    };

    callbackAutoCompleteMagistradoSubstituto = async (magistrado, option) => {
        if (!option?.valor) {
            return;
        }

        const magistradoSelecionado = toJS(option.valor);

        if (this.composicao.every((comp) => comp.magistrado.sigla !== magistrado.siglaSubstituto)) {
            const resultado = await this.adicionarMagistrado(magistradoSelecionado, magistrado);

            if (resultado) {
                this.mensagemStore.abrirMensagemInfo('A substituição será efetivada ao SALVAR');
            } else {
                return false;
            }
        }

        runInAction(() => ComposicaoUtil.definirSubstituto(magistrado, magistradoSelecionado));

        return true;
    };

    toggleMagistroPresidente = (_index, magistrado) => {
        ComposicaoUtil.definirPresidente(this.novaComposicao, magistrado);
    };

    ok = async () => {
        const novaComposicao = toJS(this.novaComposicao);
        const composicaoAnterior = toJS(this.registro.composicao);
        const listaComposicao = this.listaComposicao(novaComposicao);

        await this.processoService.gravarComposicaoProcesso(
            this.registro.sessaoId,
            this.registro.processo.numeroCompleto,
            listaComposicao
        );

        if (this.atualizarCertidao) {
            await this.certidaoService.atualizarResumoCertidao(
                this.sessaoStore.sessaoSelecionada,
                this.registro,
                this.registro.procurador,
                listaComposicao
            );
        }

        if (this.registro.necessitaImportacaoSalaSessao !== true) {
            runInAction(() => {
                this.registro.rascunhoCertidao = this.salaSessaoStore.renumerarObservacoes(this.conteudoCertidao);
            });
            await this.salaSessaoStore.salvarRascunhoCertidao(this.registro, this.conteudoCertidao);
        }
        const opcoes = ObservacaoCertidaoUtil.opcoesAlteracaoComposicao(this.registro, this.atualizarCertidao);
        await ObservacaoCertidaoUtil.atualizarTextosCertidao(
            this.registro,
            [
                ObservacaoCertidaoUtil.transformarAusencia(novaComposicao, composicaoAnterior, this.observacaoDeps),
                ObservacaoCertidaoUtil.transformarImpedimento(novaComposicao, composicaoAnterior, this.observacaoDeps)
            ],
            this.observacaoDeps,
            opcoes
        );
        await when(() => !this.appStore.requisicoesPendentes);

        await this.sessaoStore.recarregarProcesso(this.registro, true);

        runInAction(() => {
            const numeroCompleto = this.registro.processo.numeroCompleto;

            const impedimentosNovos = novaComposicao
                .filter((comp) => comp.magistrado.situacaoImpedimento)
                .map((comp) => ({
                    magistrado: {
                        sigla: comp.magistrado.sigla,
                        cpf: comp.magistrado.cpf,
                        nome: comp.magistrado.nome
                    },
                    situacaoImpedimento: comp.magistrado.situacaoImpedimento,
                    numeroProcesso: numeroCompleto
                }));

            const siglasDaComposicaoAtual = new Set(novaComposicao.map((comp) => comp.magistrado.sigla));
            const impedimentosDeOutrosMagistrados = (this.registro.impedimentos || []).filter(
                (imp) => !siglasDaComposicaoAtual.has(imp.magistrado?.sigla)
            );

            const novosImpedimentos = [...impedimentosDeOutrosMagistrados, ...impedimentosNovos];

            this.registro.composicao = novaComposicao;
            this.registro.impedimentos = novosImpedimentos;

            if (this.sessaoStore.storeFuncionalidade?.processoExpandido) {
                this.sessaoStore.storeFuncionalidade.processoExpandido.composicao = novaComposicao;
                this.sessaoStore.storeFuncionalidade.processoExpandido.impedimentos = novosImpedimentos;
            }

            this.props.onClose?.();
        });

        this.fotoMagistradoStore.carregarFotosPelaComposicaoProcesso(this.registro.composicao);
        this.mensagemStore.abrirMensagemSucesso('Nova composição salva com sucesso.');
    };

    removerSubstituto = (magistrado, substituto) => {
        runInAction(() => (this.fraseDialogRemocao = 'O magistrado substituto será removido da composição. Confirma?'));
        this.magistradoParaRemover = substituto;
        this.abrirDialogoRemocao();
    };

    cancel = async () => {
        if (!this.registro.rascunhoCertidao) {
            await this.carregarRascunhoCertidao();
        }

        runInAction(
            () =>
                (this.registro.rascunhoCertidao = this.salaSessaoStore.renumerarObservacoes(
                    this.registro.rascunhoCertidao
                ))
        );

        this.fechar();
    };

    handleChangeAtualizarCertidao = () => {
        this.atualizarCertidao = !this.atualizarCertidao;
    };

    handleClickRedefinirParaComposicaoPadrao = () => {
        if (ComposicaoUtil.mesmosMagistrados(this.novaComposicao, this.composicaoPadraoSessao)) {
            return;
        }
        this.novaComposicao = toJS(this.composicaoPadraoSessao);
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            observacaoDeps: false,
            composicaoFoiAlterada: false,
            deveDesabilitarBotaoSalvar: false,
            removerMagistradoComRestricao: action,
            renderRedefinirParaComposicaoPadrao: false,
            handleClickRedefinirParaComposicaoPadrao: action,
            novaComposicaoInicial: false,
            componentDidMount: false,
            componentDidUpdate: false,
            onModalOpen: action,
            resetarEstadoModal: action,
            fecharSemEdicao: false,
            renderModalComposicao: false,
            completarMagistradosSubstituidos: action,
            isMagistradoSubstituto: false,
            impedirRemocao: false,
            isRelatorOuRedator: false,
            getRestricoes: false,
            tentaAdicionarMagistrado: false,
            validarLocalizacaoMagistrado: false,
            listaComposicao: false,
            existePresidenteNaComposicao: false,
            getRolesMagistrado: false,
            renderExibirAtualizarCertidao: false,
            renderSubstituicao: false,
            renderAdicionarRemoverMagistradoSubstituto: false,
            renderComboSubstituicaoOuMensagemInformativa: false,
            renderMarcarImpedimentoDeclarado: false,
            renderMarcarImpedimentoPossivel: false,
            renderMarcarAusencia: false,
            renderAdicionarMagistrado: false,
            renderCarregando: false,
            render: false,
            novaComposicao: observable,
            magistradoParaAdicionar: observable,
            dialogRemocaoAberto: observable,
            fraseDialogRemocao: observable,
            magistradoParaRemover: observable,
            atualizarCertidao: observable,
            exibirAtualizarCertidao: observable,
            modalConfirmacaoOpen: observable,
            conteudoCertidao: computed,
            carregarRascunhoCertidao: action,
            callbackConfirmar: action,
            callbackCancelar: action,
            fechar: action,
            magistrados: computed,
            registro: computed,
            opcoesMagistradosAdicionar: computed,
            magistradosFiltrados: computed,
            toggleMagistradoAusente: action,
            toggleMagistradoImpedido: action,
            callbackAutoCompleteAddMagistrado: action,
            abrirDialogoRemocao: action,
            fecharDialogoRemocao: action,
            handleClickRemoverMagistrado: action,
            removerMagistrado: action,
            impedimentos: computed,
            adicionarMagistrado: action,
            callbackAutoCompleteMagistradoSubstituto: action,
            toggleMagistroPresidente: action,
            ok: action,
            removerSubstituto: action,
            cancel: action,
            composicao: computed,
            handleChangeAtualizarCertidao: action,
            isCarregando: computed,
            renderDialogRemocao: false,
            renderTituloDialog: false,
            composicaoPadraoSessao: computed,
            opcoesMagistrados: computed
        });

        this.createReaction(
            reaction(
                () => this.registro,
                () => {
                    if (this.registro.composicao) {
                        this.novaComposicao = toJS(this.registro.composicao);
                    }
                },
                { fireImmediately: true }
            )
        );

        reaction(
            () => this.novaComposicao,
            () => {
                for (const composicao of this.novaComposicao) {
                    if (composicao.magistrado.ausente) {
                        composicao.magistrado.situacaoImpedimento = undefined;
                        continue;
                    }

                    const impedimento = this.impedimentos.find(
                        (imp) => imp.magistrado.sigla === composicao.magistrado.sigla
                    );
                    composicao.magistrado.situacaoImpedimento = impedimento
                        ? impedimento.situacaoImpedimento
                        : undefined;
                }
            }
        );
    }

    componentDidMount() {
        if (!this.props.open) return;
        this.onModalOpen();
        this.novaComposicaoInicial = JSON.stringify(toJS(this.listaComposicao(this.novaComposicao)));
    }

    componentDidUpdate(previousProps) {
        const abriuDialog = this.props.open && !previousProps.open;

        if (abriuDialog) {
            this.onModalOpen();
            this.novaComposicaoInicial = JSON.stringify(toJS(this.listaComposicao(this.novaComposicao)));
        }
    }

    get conteudoCertidao() {
        return this.registro.rascunhoCertidao ?? '';
    }

    get opcoesMagistrados() {
        return getOpcoesMagistrados(this.dominioStore, this.impedimentos);
    }

    get composicaoPadraoSessao() {
        return getComposicaoPadraoSessao(this.sessaoStore, this.opcoesMagistrados);
    }

    get observacaoDeps() {
        return {
            salaSessaoStore: this.salaSessaoStore,
            certidaoService: this.certidaoService,
            sessaoStore: this.sessaoStore
        };
    }

    async carregarRascunhoCertidao() {
        let rascunho = await this.certidaoService.recuperarRascunhoCertidao(this.registro);
        rascunho = this.salaSessaoStore.renumerarObservacoes(rascunho);
        runInAction(() => (this.registro.rascunhoCertidao = rascunho));
    }

    renderModalComposicao() {
        return (
            <ModalConfirmacao
                callbackCancelar={this.callbackCancelar}
                callbackConfirmar={this.callbackConfirmar}
                open={this.modalConfirmacaoOpen}
                titulo={'Descartar alterações feitas?'}
            >
                <Typography>Há alterações NÃO salvas. Clicando SIM as alterações serão DESCARTADAS.</Typography>
            </ModalConfirmacao>
        );
    }

    get magistrados() {
        return this.dominioStore.opcoesMagistradosAutoComplete(this.registro);
    }

    get registro() {
        return this.observableProps.registro;
    }

    get opcoesMagistradosAdicionar() {
        return aplicarIconesImpedimento(this.magistradosFiltrados, this.impedimentos);
    }

    get magistradosFiltrados() {
        return filtrarOpcoesDisponiveis(
            this.magistrados,
            this.novaComposicao,
            ComposicaoUtil.localizacaoUsuario(this.usuarioStore)
        );
    }

    isMagistradoSubstituto(magistrado) {
        return this.novaComposicao.some((comp) => comp.magistrado.siglaSubstituto === magistrado.sigla);
    }

    impedirRemocao(magistrado) {
        return this.isRelatorOuRedator(magistrado);
    }

    isRelatorOuRedator(magistrado) {
        return this.getRolesMagistrado(magistrado).relator || this.getRolesMagistrado(magistrado).redator;
    }

    getRestricoes(magistrado, roles) {
        const generoSubstituto = magistrado.genero === 'M' ? 'o' : 'a';
        const generoRelatorERedator = magistrado.genero === 'M' ? '' : 'a';
        const roleStringArray = [];
        const numerosProcessos = filtrarImpedimentosMagistrado(magistrado, this.impedimentos).map(
            (imp) => imp.numeroProcesso
        );
        const complemento = numerosProcessos && numerosProcessos.length > 1 ? 'nos processos:' : 'no processo';

        if (magistrado.presidenteSessao) {
            roleStringArray.push('presidente da sessão');
        }
        if (this.isMagistradoSubstituto(magistrado)) {
            roleStringArray.push(`subtitut${generoSubstituto} de outro magistrado`);
        }
        if (magistrado.situacaoImpedimento) {
            roleStringArray.push(`impedid${generoSubstituto} ${complemento}`);
        }
        if (roles.relator) {
            roleStringArray.push(`relator${generoRelatorERedator}`);
        }
        if (roles.redator) {
            roleStringArray.push(`redator${generoRelatorERedator}`);
        }
        let roleString = roleStringArray.join(', ');

        const index = roleString.lastIndexOf(',');

        if (index !== -1) {
            roleString = roleString.slice(0, index) + roleString.slice(index).replace(',', ' e');
        }
        return roleString + (roles.relator || roles.redator ? ' do processo' : '');
    }

    get impedimentos() {
        return this.registro.impedimentos || [];
    }

    async tentaAdicionarMagistrado(magistrado, substituido) {
        let isRetorno = false;
        const situacao = await this.validarLocalizacaoMagistrado(magistrado);

        if (situacao.tipo === 'SUCESSO') {
            runInAction(() => {
                const magistradoParaAdicionar = toJS(magistrado);
                const impedimento = this.impedimentos.find(
                    (imped) => imped.magistrado.sigla === magistradoParaAdicionar.sigla
                );
                const novoMagistrado = ComposicaoUtil.criarEntradaComposicao(magistradoParaAdicionar, {
                    impedido: this.salaSessaoStore.isMagistradoImpedido(magistradoParaAdicionar.sigla, this.registro),
                    situacaoImpedimento: impedimento?.situacaoImpedimento,
                    suspeito: false,
                    magistradoSubstituto: { sigla: '' },
                    ...(substituido && { magistradoSubstituido: substituido })
                });

                this.novaComposicao.push(novoMagistrado);

                this.magistradoParaAdicionar = {};
                isRetorno = true;

                ComposicaoUtil.rolarParaFim('#tBodyComposicaoProcesso');
            });
        } else {
            this.mensagemStore.abrirMensagemAlerta(situacao.mensagem);
        }
        return isRetorno;
    }

    validarLocalizacaoMagistrado(magistrado) {
        return this.registro.processo.origem === Configuracao.ORIGEM_SIJ
            ? Promise.resolve({ tipo: 'SUCESSO' })
            : this.sessaoStore.verificarLocalizacaoMagistrado(this.registro.sessaoId, magistrado);
    }

    listaComposicao(composicao) {
        const processo = this.registro.processo;

        return composicao.map((comp) => {
            return {
                id: comp.magistrado.id,
                presidenteSessao: comp.magistrado.presidenteSessao,
                sigla: comp.magistrado.sigla,
                ausente: comp.magistrado.ausente,
                situacaoImpedimento: comp.magistrado.situacaoImpedimento,
                suspeito: comp.magistrado.suspeito,
                magistradoSubstituto: comp.magistrado.magistradoSubstituto,
                magistradoSubstituido: comp.magistrado.magistradoSubstituido ?? null,
                relator: !!(processo.relator && processo.relator.sigla === comp.magistrado.sigla),
                codigoCargo: comp.magistrado.codigoCargo,
                genero: comp.magistrado.genero,
                nome: comp.magistrado.nome,
                cpf: comp.magistrado.cpf,
                converterSigla:
                    comp.magistrado.converterSigla ?? comp.magistrado.sigla !== comp.magistrado.siglaAdministrativa,
                siglaAdministrativa: comp.magistrado.siglaAdministrativa,
                siglaSubstituto: comp.magistrado.siglaSubstituto
            };
        });
    }

    get composicao() {
        return this.novaComposicao.toSorted((comp1, comp2) => {
            const siglaRelator = this.registro?.processo?.relator?.sigla;

            if (comp1.magistrado.sigla === siglaRelator) {
                return -1;
            }
            if (comp2.magistrado.sigla === siglaRelator) {
                return 1;
            }

            const siglaRedator = this.registro?.processo?.redator?.sigla;

            if (comp1.magistrado.sigla === siglaRedator) {
                return -1;
            }
            return comp2.magistrado.sigla === siglaRedator ? 1 : 0;
        });
    }

    get composicaoFoiAlterada() {
        const composicaoInicial =
            typeof this.novaComposicaoInicial === 'string'
                ? JSON.parse(this.novaComposicaoInicial)
                : this.novaComposicaoInicial;

        const chaveInicial = ComposicaoUtil.chaveComposicao(
            (composicaoInicial || []).map((magistrado) => ({
                magistrado
            })),
            true
        );

        const chaveAtual = ComposicaoUtil.chaveComposicao(this.novaComposicao, true);

        return chaveInicial !== chaveAtual;
    }

    get deveDesabilitarBotaoSalvar() {
        const temComposicaoValida = Boolean(this.novaComposicao && this.novaComposicao.length > 0);
        const possuiEstruturaValida = temComposicaoValida && this.existePresidenteNaComposicao();

        if (!possuiEstruturaValida) {
            return true;
        }

        const permiteSalvar = this.composicaoFoiAlterada || Boolean(this.atualizarCertidao);

        return !permiteSalvar;
    }

    existePresidenteNaComposicao() {
        return ComposicaoUtil.existePresidente(this.composicao);
    }

    getRolesMagistrado(magistrado, entradaAtual) {
        return ComposicaoUtil.getRolesMagistrado(magistrado, this.registro.processo, this.dominioStore, entradaAtual);
    }

    get isCarregando() {
        if (
            this.store.processoExpandido?.processo?.numeroCompleto &&
            this.store.processoExpandido.processo.numeroCompleto === this.registro?.processo?.numeroCompleto
        ) {
            const carregandoDetalhesProcesso = this.store.carregandoDetalhesProcesso.get(
                this.store.getChaveControleCarregamentoDetalhes(this.registro)
            );

            return !!(
                carregandoDetalhesProcesso?.carregando ||
                this.store.carregandoProcessos ||
                this.store.carregandoSessao
            );
        }

        return false;
    }

    renderExibirAtualizarCertidao() {
        if (!this.exibirAtualizarCertidao) {
            return null;
        }

        return (
            <div style={{ display: 'flex', alignItems: 'center', height: '24px' }}>
                <Checkbox
                    checked={this.atualizarCertidao}
                    onChange={this.handleChangeAtualizarCertidao}
                    sx={{ padding: '4px' }}
                />
                Atualizar composição/procurador na certidão
            </div>
        );
    }

    renderRedefinirParaComposicaoPadrao() {
        return renderBotaoRedefinirComposicao(
            this.novaComposicao,
            this.composicaoPadraoSessao,
            this.handleClickRedefinirParaComposicaoPadrao
        );
    }

    renderSubstituicao(magistrado) {
        return (
            <>
                {ComposicaoUtil.isMagistradoSubstitutoDefinido(magistrado) && renderIconeSubstituicao(magistrado)}
                {magistrado.magistradoSubstituido ? renderIconeSubstituicao(magistrado) : null}
            </>
        );
    }

    renderAdicionarRemoverMagistradoSubstituto(magistrado, index) {
        return renderCelulaSubstituto(magistrado, this.removerSubstituto, () =>
            this.renderComboSubstituicaoOuMensagemInformativa(magistrado, index)
        );
    }

    renderComboSubstituicaoOuMensagemInformativa(magistrado, index) {
        return ComposicaoUtil.shouldEsconderComboSubstituto(magistrado) ? (
            renderAvisoMagistradoJaSubstituto(magistrado)
        ) : (
            <AutoComplete
                outlined
                disabled={
                    (!magistrado.ausente && !magistrado.situacaoImpedimento) ||
                    ComposicaoUtil.isMagistradoSubstituidoDefinido(magistrado)
                }
                apresentarTextoSecundario={true}
                id={'composicao' + index}
                informarEventoOnChange={true}
                label="Selecione..."
                onChange={(evento, option) => this.callbackAutoCompleteMagistradoSubstituto(magistrado, evento, option)}
                options={this.magistradosFiltrados}
            />
        );
    }

    renderMarcarImpedimentoDeclarado(magistrado) {
        const bloqueadoPje = this.salaSessaoStore.isProcessoPje(this.registro);

        let numerosProcessosPje;

        if (this.registro.numerosProcessosPje?.length) {
            numerosProcessosPje = this.registro.numerosProcessosPje;
        } else if (bloqueadoPje) {
            numerosProcessosPje = [this.registro.processo.numeroCompleto];
        } else {
            numerosProcessosPje = [];
        }

        const complemento = numerosProcessosPje.length === 1 ? 'no processo' : 'nos processos';

        return (
            <Tooltip
                title={
                    bloqueadoPje
                        ? `Composição de processo do acervo do PJe não admite marcação de impedimento ${complemento}: ${numerosProcessosPje.join('; ')}. Verifique o cadastro de sessão de julgamento.`
                        : 'Marcar impedimento de magistrado'
                }
            >
                <span>
                    <Checkbox
                        checked={magistrado.situacaoImpedimento === 'IMPEDIMENTO_DECLARADO'}
                        disabled={bloqueadoPje || ComposicaoUtil.isMagistradoSubstitutoDefinido(magistrado)}
                        onChange={() => this.toggleMagistradoImpedido(magistrado, 'IMPEDIMENTO_DECLARADO')}
                    />
                </span>
            </Tooltip>
        );
    }

    renderMarcarImpedimentoPossivel(magistrado) {
        if (magistrado.situacaoImpedimento === 'IMPEDIMENTO_POSSIVEL') {
            return (
                <Tooltip
                    slotProps={{
                        popper: { style: { zIndex: 9_999_999 } }
                    }}
                    placement="top"
                    title="Possível impedimento"
                >
                    <div>{<ThumbDown sx={{ fillOpacity: 0.7, color: red[900] }} />}</div>
                </Tooltip>
            );
        }
    }

    renderMarcarAusencia(magistrado, index) {
        return (
            <Tooltip title={<Typography>Marcar ausência de magistrado</Typography>}>
                <Checkbox
                    disabled={
                        ComposicaoUtil.isMagistradoSubstitutoDefinido(magistrado) ||
                        ComposicaoUtil.isMagistradoSubstituidoDefinido(magistrado)
                    }
                    checked={magistrado.ausente}
                    onClick={this.toggleMagistradoAusente.bind(this, index, magistrado)}
                />
            </Tooltip>
        );
    }

    renderAdicionarMagistrado() {
        return (
            <div
                style={{
                    display: 'flex',
                    marginTop: '10px',
                    marginBottom: '4px',
                    marginLeft: '8px',
                    alignContent: 'center',
                    flexGrow: 1,
                    alignItems: 'center',
                    justifyContent: 'left'
                }}
            >
                <AutoComplete
                    outlined
                    apresentarTextoSecundario={true}
                    id={'adicionarMagistrado'}
                    label="Selecione..."
                    onChange={this.callbackAutoCompleteAddMagistrado}
                    options={this.opcoesMagistradosAdicionar}
                    value={this.magistradoParaAdicionar?.sigla ? this.magistradoParaAdicionar.texto : null}
                />
                <Tooltip title="Adicionar magistrado">
                    <div>
                        <IconButton
                            color={'primary'}
                            disabled={!this.magistradoParaAdicionar}
                            onClick={() => this.adicionarMagistrado(this.magistradoParaAdicionar)}
                            size="large"
                        >
                            <PersonAdd />
                        </IconButton>
                    </div>
                </Tooltip>
            </div>
        );
    }

    get renderDialogRemocao() {
        return renderDialogRemocao({
            aberto: this.dialogRemocaoAberto,
            frase: this.fraseDialogRemocao,
            somenteOk: this.impedirRemocao(this.magistradoParaRemover),
            onFechar: this.fecharDialogoRemocao,
            onRemover: () => this.removerMagistrado(this.magistradoParaRemover)
        });
    }

    get renderTituloDialog() {
        return (
            <Stack direction="row">
                <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-start' }}>
                    <Typography
                        display="inline"
                        sx={{ fontWeight: 'bold' }}
                    >
                        {this.props.titulo ?? 'Editar composição do processo'}
                        {this.registro?.processo?.numeroCompleto ? ` ${this.registro?.processo?.numeroCompleto}` : ''}
                    </Typography>
                </Box>
                {this.registro?.processo?.relator ? (
                    <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end' }}>
                        <RelatorChip
                            composicao={this.registro?.composicao}
                            exibirFoto={true}
                            relator={this.registro?.processo?.relator}
                            sx={{ ml: 1 }}
                        />
                    </Box>
                ) : null}
            </Stack>
        );
    }

    get renderCarregando() {
        return (
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    zIndex: 9999
                }}
            >
                <CircularProgress size={48} />
            </Box>
        );
    }

    render() {
        return (
            <Dialog
                slotProps={{
                    paper: {
                        sx: {
                            height: '80vh'
                        }
                    }
                }}
                maxWidth="xl"
                onClose={this.fechar}
                open={this.props.open}
            >
                <DialogTitle>{this.renderTituloDialog}</DialogTitle>
                <DialogContent sx={{ height: '100%', position: 'relative' }}>
                    {this.isCarregando ? (
                        this.renderCarregando
                    ) : (
                        <>
                            <div
                                style={{
                                    margin: '0px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    flexDirection: 'row'
                                }}
                            >
                                {this.renderExibirAtualizarCertidao()}
                            </div>
                            <Table sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100% - 20px)' }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            align="center"
                                            sx={{ width: '105px' }}
                                        >
                                            Magistrado
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            sx={{ width: '80px' }}
                                        >
                                            Presidente
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            sx={{ width: '80px' }}
                                        >
                                            Ausente
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            sx={{ width: '80px' }}
                                        >
                                            Possível impedimento
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            sx={{ width: '80px' }}
                                        >
                                            Impedimento declarado
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            sx={{ width: '105px' }}
                                        >
                                            Substituto
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            sx={{ width: '78px' }}
                                        />
                                    </TableRow>
                                </TableHead>
                                <TableBody
                                    id="tBodyComposicaoProcesso"
                                    sx={{ flex: 1, overflowY: 'auto' }}
                                >
                                    {this.composicao.length > 0 &&
                                        this.composicao.map((composicao, index) => {
                                            const magistrado = composicao.magistrado;

                                            if (!magistrado.sigla) {
                                                return null;
                                            }
                                            const entradaAtual = ComposicaoUtil.getEntradaDominioAtual(
                                                magistrado,
                                                this.dominioStore
                                            );
                                            const roles = this.getRolesMagistrado(magistrado, entradaAtual);
                                            const estiloChip = ComposicaoUtil.estiloChipMagistrado(roles);
                                            const title = ComposicaoUtil.defineTitle(
                                                roles,
                                                magistrado.nome,
                                                magistrado,
                                                ComposicaoUtil.defineRedatorRelator
                                            );

                                            return (
                                                <TableRow key={magistrado.sigla}>
                                                    <TableCell
                                                        align="center"
                                                        sx={{ width: '105px' }}
                                                    >
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <Tooltip
                                                                sx={{ whiteSpace: 'pre-line' }}
                                                                title={title || ''}
                                                            >
                                                                <Chip
                                                                    label={magistrado.sigla}
                                                                    sx={estiloChip}
                                                                />
                                                            </Tooltip>
                                                            {renderChipOrigemSigla(entradaAtual)}
                                                            <BotaoAlternarSigla
                                                                registroVirtualComposicao={
                                                                    this.registroVirtualComposicao
                                                                }
                                                                dominioStore={this.dominioStore}
                                                                magistrado={composicao.magistrado}
                                                                novaComposicao={this.novaComposicao}
                                                                salaSessaoStore={this.salaSessaoStore}
                                                            />
                                                            {this.renderSubstituicao(magistrado)}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        sx={{ width: '80px' }}
                                                    >
                                                        <Radio
                                                            disabled={ComposicaoUtil.isMagistradoSubstitutoDefinido(
                                                                magistrado
                                                            )}
                                                            onChange={this.toggleMagistroPresidente.bind(
                                                                this,
                                                                index,
                                                                magistrado
                                                            )}
                                                            checked={magistrado.presidenteSessao === true}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        sx={{ width: '80px' }}
                                                    >
                                                        {this.renderMarcarAusencia(magistrado, index)}
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        sx={{ width: '80px' }}
                                                    >
                                                        {this.renderMarcarImpedimentoPossivel(magistrado)}
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        sx={{ width: '80px' }}
                                                    >
                                                        {this.renderMarcarImpedimentoDeclarado(magistrado)}
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        sx={{ width: '105px' }}
                                                    >
                                                        {this.renderAdicionarRemoverMagistradoSubstituto(
                                                            magistrado,
                                                            index
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Tooltip
                                                            placement="left"
                                                            title="Remover"
                                                        >
                                                            <IconButton
                                                                disabled={ComposicaoUtil.isMagistradoSubstitutoDefinido(
                                                                    magistrado
                                                                )}
                                                                onClick={this.handleClickRemoverMagistrado.bind(
                                                                    this,
                                                                    magistrado
                                                                )}
                                                                size="large"
                                                                sx={{ cursor: 'pointer', padding: '4px' }}
                                                            >
                                                                <Clear />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                            {this.renderDialogRemocao}
                        </>
                    )}
                </DialogContent>
                <DialogActions sx={{ mt: 2, ml: 3, mr: 3, mb: 2 }}>
                    {this.isCarregando ? (
                        <Button
                            color="secondary"
                            endIcon={<CancelIcon />}
                            onClick={this.fecharSemEdicao}
                            variant="outlined"
                        >
                            Cancelar
                        </Button>
                    ) : (
                        <>
                            {this.renderAdicionarMagistrado()}
                            {this.renderRedefinirParaComposicaoPadrao()}
                            {this.renderModalComposicao()}
                            <Button
                                color="secondary"
                                endIcon={<CancelIcon />}
                                onClick={this.cancel}
                                variant="outlined"
                            >
                                Cancelar
                            </Button>
                            <Tooltip
                                title={ComposicaoUtil.tooltipBotaoSalvar(
                                    this.existePresidenteNaComposicao,
                                    this.composicaoFoiAlterada,
                                    this.atualizarCertidao
                                )}
                            >
                                <span>
                                    <Button
                                        color="primary"
                                        disabled={this.deveDesabilitarBotaoSalvar}
                                        endIcon={<SaveIcon />}
                                        onClick={this.ok}
                                        variant="contained"
                                    >
                                        Salvar
                                    </Button>
                                </span>
                            </Tooltip>
                        </>
                    )}
                </DialogActions>
            </Dialog>
        );
    }
}

export default inject('stores')(observer(ModalComposicao));
